/* eslint-disable no-unused-vars */
import Vue from 'vue'
import VueRouter from 'vue-router'

import adminRoutes from '@/routes/admin'
import organizerRoutes from '@/routes/organizer'
import jijeRoutes from '@/routes/jije'
import entrepreneurRoutes from '@/routes/entrepreneur'
import evaluatorRoutes from '@/routes/evaluator'
import tutorRoutes from '@/routes/tutor'

import index from '@/pages/landing/index.vue'
import postulate from '@/pages/landing/postulate.vue'

import Login from '@/pages/auth/Login.vue'
import PasswordRecovery from '@/pages/auth/PasswordRecovery.vue'
import setPasswordRecovery from '@/pages/auth/setPasswordRecovery.vue'
import PostulateProject from '@/pages/auth/PostulateProject.vue'
import RegisterParticipant from '@/pages/auth/RegisterParticipant.vue'
import Invitation from '@/pages/auth/Invitation.vue'
import InvitationVip from '@/pages/auth/InvitationVip.vue'

import Profile from '@/pages/profile/Profile.vue'
import messages from '@/pages/messages/Messages.vue'
import chat from '@/pages/messages/Chat.vue'
import NotFound from '@/pages/NotFoundPage.vue'

Vue.use(VueRouter)

const routes2= [
    {
      path: '/',
      name: 'index',
      component: index
    },
    {
      path: '/postulate/:slug',
      name: 'postulate',
      component: postulate
    },
    {
      path: '/login',
      name: 'login',
      component: Login
    },
    {
      path: '/password-recovery',
      name: 'PasswordRecovery',
      component: PasswordRecovery
    },
    {
      path: '/password-recovery/:url',
      name: 'setPasswordRecovery',
      component: setPasswordRecovery
    },
    {
      path: '/postulate-project/:slug',
      name: 'PostulateProject',
      component: PostulateProject
    },
    {
      path: '/register-participant/:slug',
      name: 'RegisterParticipant',
      component: RegisterParticipant
    },
    {
      path: '/invitation/:url',
      name: 'Invitation',
      component: Invitation
    },
    {
      path: '/invitation-vip/:url',
      name: 'InvitationVip',
      component: InvitationVip
    },
    {
      path: '/profile',
      name: 'profile',
      component: Profile,
      meta: {
        auth: true,
        breadCrumb: [
          {
            text: 'Home',
            to: { name: 'home' }
          },
          {
            text: 'Editar cuenta'
          }
        ]
      }
    },
    
    {
      path: '/messages',
      name: 'messages',
      component: messages,
      meta: {
        auth: true,
        breadCrumb: [
          {
            text: 'Home',
            to: { name: 'home' }
          },
          {
            text: 'Mensajes'
          }
        ]
      }
    },
    {
      path: '/messages/:id',
      name: 'chat',
      component: chat,
      meta: {
        auth: true,
        breadCrumb: [
          {
            text: 'Home',
            to: { name: 'home' }
          },
          {
            text: 'Mensajes',
            to: { name: 'messages' }
          },
          {
            text: 'Ver'
          }
        ]
      }
    },
    {
      path: '*',
      name: 'NotFound',
      component: NotFound,
      meta: {
        breadCrumb: [
          {
            text: 'Pagina no encontrada'
          }
        ]
      }
    },
  ]

const routes = routes2.concat(adminRoutes, organizerRoutes, jijeRoutes, entrepreneurRoutes, evaluatorRoutes, tutorRoutes)

  const router = new VueRouter({
    mode: 'history',
    base: process.env.BASE_URL,
    routes,
    scrollBehavior(to, from, savedPosition) {
      // always scroll to top
      document.getElementById('app').scrollIntoView({ behavior: 'smooth' });
    },
  })

  router.onError((error) => {
    const pattern = /Loading chunk [\d]+ failed/g;
    const isChunkLoadFailed = error.message.match(pattern);
    const targetPath = router.history.pending.fullPath;
    if (isChunkLoadFailed) {
      router.replace(targetPath);
    }
  })

  router.beforeEach((to, from, next) => {
    const loggedIn = localStorage.getItem('user')
    if (to.matched.some(record => record.meta.auth) && !loggedIn) {
      next('/login')
      return
    }
    next()
  })
  
  export default router